export const blockIconsPhotoandimageCenterFocusStrongNew = (
	<span className='material-symbols-outlined'>center_focus_strong</span>
);
